// extracted by mini-css-extract-plugin
export default {"title":"FXStatusTime_title__j325Q","description":"FXStatusTime_description__eWZJF","marketTimer":"FXStatusTime_marketTimer__nZaku"};